import { isAffiliate } from '@anm/helpers/affiliate';
import isServer from '@anm/helpers/is/isServer';
import { composeUrlQuery } from '@anm/helpers/parseParams';
import getUTMQuery from '@anm/helpers/utm/getUTMQuery';
import { FC } from 'react';
import { compose, lifecycle } from 'recompose';

import withModalControls, {
  WithModalControlsProps
} from '../../HOCs/withModalControls';
import lfConfig from '../../config';

import DiscountContent from './DiscountContent';
import { ModalWrapper } from './Wrapper';

const openSignUpPage = () => {
  location.href = `${lfConfig.waveUrl}signup${composeUrlQuery(getUTMQuery())}`;
};

const AffiliateDiscountModal: FC<WithModalControlsProps> = ({
  closeModal,
  isModalOpened
}) => {
  if (isServer() || !isModalOpened) return null;

  return (
    <ModalWrapper
      closeModal={closeModal}
      modalWidth={380}
      modalHeight={500}
      isModalOpened={isModalOpened}
    >
      <DiscountContent onOk={openSignUpPage} onCancel={closeModal} />
    </ModalWrapper>
  );
};

function componentDidMount(this: { props: WithModalControlsProps }) {
  const { openModal } = this.props;
  isAffiliate() && openModal();
}

export default compose(
  withModalControls,
  lifecycle<WithModalControlsProps, {}>({ componentDidMount })
)(AffiliateDiscountModal);
